
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invest/company/[slug]",
      function () {
        return require("private-next-pages/invest/company/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invest/company/[slug]"])
      });
    }
  